<p class="info">
  {{ 'semver.info' | translate }}:
  <davinci-link href="https://semver.org" target="_blank" insideText>{{ 'semver.format' | translate }}</davinci-link>
</p>
